import React from 'react'

const ageGroups = [
  {
    range: "12-15 ans",
    icon: "👦",
    focus: "Initiation ludique à la programmation",
    approach: "Apprentissage par le jeu et projets créatifs simples",
    projects: "Jeux simples, animations, sites web basiques"
  },
  {
    range: "16-18 ans",
    icon: "👨‍🎓",
    focus: "Fondamentaux solides et projets personnels",
    approach: "Approche pratique avec réalisation de projets concrets",
    projects: "Applications web, jeux, outils utilitaires"
  },
  {
    range: "Adultes",
    icon: "👨‍💼",
    focus: "Développement professionnel et applications réelles",
    approach: "Orientation vers des compétences professionnelles utilisables",
    projects: "Applications complètes, portfolios, projets entrepreneuriaux"
  }
]

function AgeGroups() {
  return (
    <section className="py-20 bg-light-5">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-title font-bold text-dark-2 text-center mb-12">👥 Programme adapté à chaque tranche d'âge</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {ageGroups.map((group, idx) => (
            <div key={idx} className="bg-white rounded-2xl p-6">
              <div className="text-4xl mb-4 text-center">{group.icon}</div>
              <h3 className="text-xl font-bold text-dark-2 text-center mb-4">{group.range}</h3>
              <div className="space-y-3">
                <div>
                  <h4 className="font-semibold text-dark-3">Focus:</h4>
                  <p className="text-dark-2">{group.focus}</p>
                </div>
                <div>
                  <h4 className="font-semibold text-dark-3">Approche:</h4>
                  <p className="text-dark-2">{group.approach}</p>
                </div>
                <div>
                  <h4 className="font-semibold text-dark-3">Exemples de projets:</h4>
                  <p className="text-dark-2">{group.projects}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default AgeGroups